// extracted by mini-css-extract-plugin
export var locationCard = "_fh-0";